// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3VBNJ","label":"CategoryService_label__12Tbf","location":"CategoryService_location__3iS90"};